<ion-footer class="main-footer" *ngIf="showFooter">
    <ion-toolbar>
        <div class="mss-footer large-wrapper" *ngIf="!showGeneralFooterType">
            <div class="mss-footer__action">
                <div class="mss-footer__back" id="focusBack" #focusBack *ngIf="showBackButton" (click)="goBack()">
                    <i class="fa fa-caret-left"></i> {{ lang.data['action.back'] }}
                </div>
            </div>
            <div class="mss-footer__home pointer" (click)="goHome()">
                <img alt="MySupportSpace Discover" src="assets/icons/footer_home.png"/>
                <span>{{ lang.data['general.home'] }}</span>
            </div>
            <div class="mss-footer__save">
                <ion-button *ngIf="showSaveButton" (click)="saveArticle()" class="secondary" size="small" shape="round">
                    {{ lang.data['action.save'] }}
                </ion-button>
                <ion-button *ngIf="showRemoveButton" (click)="removeArticle()" class="secondary" size="small"
                            shape="round">
                    {{ lang.data['action.unsave'] }}
                </ion-button>
            </div>
        </div>


        <div class="mss-footer mss-footer__general large-wrapper" *ngIf="showGeneralFooterType">
            <div class="mss-footer__discover mfi pointer" (click)="goHome()"
                 [ngClass]="isDiscoverPage ? 'mfi-active' : ''">
                <img alt="MySupportSpace Discover" [src]="isDiscoverPage ? 'assets/icons/home_active.png' : 'assets/icons/Home.svg'" />
                {{ lang.data['action.discover'] }}
            </div>
            <div class="mss-footer__mood mfi pointer" (click)="goToMoodLog()"
                 [ngClass]="isMoodLogPage ? 'mfi-active' : ''">
                <img alt="MySupportSpace Mood log" [src]="isMoodLogPage ? 'assets/icons/mood_log_active.png' : 'assets/icons/Log.svg'"/>
                {{ lang.data['label.mood_log'] }}
            </div>

            <div class="mss-footer__crisis mfi pointer"
                 *ngIf="crisisModeEnabled"
                 (click)="goToCrisis()"
                 [ngClass]="isCrisisPage ? 'mfi-active' : ''">
                <img alt="MySupportSpace Profile" [src]="isCrisisPage ? 'assets/icons/crisis_active.png' : 'assets/icons/crisis_inactive.png'"/>
                {{ lang.data['label.crisis'] }}
            </div>
            <div class="mss-footer__chat mfi pointer" (click)="openLiveChat()">
                <img alt="MySupportSpace Chat" src="assets/icons/Contact.svg"/>
                {{ lang.data['label.chat'] }}
            </div>
        </div>

    </ion-toolbar>
</ion-footer>
